import { useEffect, useState } from 'react';
import { API } from '@/services/api.service';

/**
 * Assigned users, work-type list, signature preview and the expanded state of the settings blocks.
 */
export default function useCompanyFormSideState({
  baselineRef,
  clientsAdminsClientOfficersKeys,
  clientsAdminsClientsKeys,
  clientsAdminsCompanyAdminsKeys,
  clientsAdminsEInvoiceOfficersKeys,
  form,
  formData,
  isProfile,
}) {
  useEffect(() => {
    const getUsersById = (users) => {
      return users?.map(({ _id }) => _id) || [];
    };

    // * Set initial values on Edit Company form
    if (formData) {
      form.setFieldsValue({
        ...formData,
        generalData: {
          ...formData.generalData,
          mainCompany: formData.generalData?.mainCompany?._id || undefined,
        },
        [clientsAdminsClientsKeys]: getUsersById(
          formData.clientsAdmins?.clients
        ),
        [clientsAdminsClientOfficersKeys]: getUsersById(
          formData.clientsAdmins?.clientOfficers
        ),
        [clientsAdminsEInvoiceOfficersKeys]: getUsersById(
          formData.clientsAdmins?.eInvoiceOfficers
        ),
        [clientsAdminsCompanyAdminsKeys]: getUsersById(
          formData.clientsAdmins?.companyAdmins
        ),
      });
      // The store is replaced immutably on every change, so this reference
      // keeps the loaded values.
      baselineRef.current = form.getFieldsValue(true);
    }
  }, [
    formData,
    form,
    clientsAdminsClientsKeys,
    clientsAdminsClientOfficersKeys,
    clientsAdminsEInvoiceOfficersKeys,
    clientsAdminsCompanyAdminsKeys,
  ]);

  // * WORK TYPE ENUMS
  const [workTypesForSelect, setWorkTypesForSelect] = useState([]);

  // * SIGNATURE
  const signatureKey =
    formData?.authorizedRepresentatives?.signature?.key || null;
  const [existingSignature, setExistingSignature] = useState(null);
  // On the profile each group is its own tile, so its settings start open.
  const [hrExpanded, setHrExpanded] = useState(isProfile);
  const [eInvoiceExpanded, setEInvoiceExpanded] = useState(isProfile);
  const [timeTrackingExpanded, setTimeTrackingExpanded] = useState(isProfile);
  const [timesheetReviewExpanded, setTimesheetReviewExpanded] =
    useState(isProfile);

  useEffect(() => {
    const fetchSignatureUrl = async () => {
      if (signatureKey) {
        try {
          const { url } = await API.files.downloadFile({ key: signatureKey });
          setExistingSignature(url);
        } catch (error) {
          console.error('Failed to fetch signature URL:', error);
        }
      } else {
        setExistingSignature(null);
      }
    };
    fetchSignatureUrl();
  }, [signatureKey]);

  return {
    eInvoiceExpanded,
    existingSignature,
    hrExpanded,
    setEInvoiceExpanded,
    setHrExpanded,
    setTimeTrackingExpanded,
    setTimesheetReviewExpanded,
    setWorkTypesForSelect,
    signatureKey,
    timeTrackingExpanded,
    timesheetReviewExpanded,
    workTypesForSelect,
  };
}
